import Vue from 'vue'
import VueRouter from 'vue-router';
import { upperFirst } from './helpers'
import Landing from "@/views/Landing";
import ProgramInscription from "@/views/ProgramInscription";
import AcademiaEgresadosInscription from "@/views/AcademiaEgresadosInscription";
import Step1 from "@/views/inscription-steps/Step1";
import Step2 from "@/views/inscription-steps/Step2";
import Step3 from "@/views/inscription-steps/Step3";
import Step4 from "@/views/inscription-steps/Step4";
import ReStep1 from "@/views/course-recommended/Step1";
import ReStep2 from "@/views/course-recommended/Step2";
import ReStep3 from "@/views/course-recommended/Step3";
import ReStep4 from "@/views/course-recommended/Step4";
import PurchaseConfirmation from "@/components/purchase/PurchaseConfirmation.vue";
import PurchaseRejected from "@/components/purchase/PurchaseRejected.vue";
import SuccessInscription from "@/views/SuccessInscription";
import BuyOtherProgram from "@/views/BuyOtherProgram";
import NotFound from "@/views/404";
import Preloader from "@/components/Preloader";
import componentsTest from "@/views/componentsTest";
import BackpackPageMobile from "@/views/BackpackPageMobile";
import Voucher from "@/views/Voucher";
import Outlet1 from "@/views/outlet-steps/Step1";
import Outlet2 from "@/views/outlet-steps/Step2";
import Outlet3 from "@/views/outlet-steps/Step3";
// New version imports
import NewVersionPurchase from "@/views/new-version/Purchase";
import StepperWrapper from "@/views/new-version/StepperWrapper";
import NewHome from "@/views/new-version/NewHome";

Vue.use(VueRouter);

const routes = [
    {
        path: '',
        component: Landing,
        name: 'Landing'
    },

    {
        path: '/inscripcion',
        component: ProgramInscription,
        name: 'ProgramInscription'
    },

    {
        path: '/academia-egresados',
        component: AcademiaEgresadosInscription,
        name: 'AcademiaEgresadosInscription'
    },

    {
        path: '/inscripcion-paso-1',
        component: Step1,
        name: 'Step1',
        requireStorageKey: 'selectedProgram;students'
    },

    {
        path: '/inscripcion-paso-2',
        component: Step2,
        name: 'Step2',
        requireStorageKey: 'selectedSubjects;selectedLocation;selectedCourses'
    },

    {
        path: '/inscripcion-paso-3',
        component: Step3,
        name: 'Step3',
        requireStorageKey: 'studentsWithPrices'
    },

    {
        path: '/inscripcion-paso-4',
        component: Step4,
        name: 'Step4',
        requireStorageKey: 'fullOrder'
    },

    // {
    //     path: '/informacion-compra',
    //     component: CheckInStep1,
    //     name: 'CheckInStep1'
    // },

    {
        path: '/informacion-compra',
        component: PurchaseConfirmation,
        name: 'CheckInStep1'
    },
    {
        path: '/informacion-compra-rechazada',
        component: PurchaseRejected,
        name: 'PurchaseRejected'
    },

    {
        path: '/inscripcion-exitosa',
        component: SuccessInscription,
        name: 'SuccessInscription'
    },

    {
        path: '/agregar-otro-alumno',
        component: BuyOtherProgram,
        name: 'BuyOtherProgram'
    },

    {
        path: '/preloader',
        component: Preloader,
        name: 'Preloader'
    },

    {
        path: '/components',
        component: componentsTest,
        name: 'componentsTest'
    },

    {
        path: '/mochila',
        component: BackpackPageMobile,
        name: 'BackpackPageMobile'
    },
    {
        path: '/comprobante/:buyorder',
        component: Voucher,
        name: 'Comprobante Pago'
    },

    {
        path: '/404',
        component: NotFound,
        name: '404'
    },

    /* 404 - always has to be the last one*/
    { path: '*', redirect: { name: '404' } },
    {
        path: '/recomendado-paso-1',
        component: ReStep1,
        name: 'Re-Step1',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/recomendado-paso-2',
        component: ReStep2,
        name: 'Re-Step2',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/recomendado-paso-3',
        component: ReStep3,
        name: 'Re-Step3',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/recomendado-paso-4',
        component: ReStep4,
        name: 'Re-Step4',
        // requireStorageKey : 'selectedProgram;students'
    },
    {
        path: '/packpdv',
        component: Outlet1,
        name: 'Outlet1',
        requireStorageKey: '#',
        meta: { showWhatsApp: true, hidePersonalizedAttention: true }
    },

    {
        path: '/alianzas',
        component: Outlet1,
        name: 'AllianceOutlet1',
        requireStorageKey: '#',
        meta: { showWhatsApp: true, hidePersonalizedAttention: true, isAllianceMode: true }
    },

    {
        path: '/packpdv-2',
        component: Outlet2,
        name: 'Outlet2',
        requireStorageKey: '#',
        meta: { showWhatsApp: true, hidePersonalizedAttention: true }
    },

    {
        path: '/packpdv-3',
        component: Outlet3,
        name: 'Outlet3',
        requireStorageKey: '#',
        meta: { showWhatsApp: true, hidePersonalizedAttention: true }
    },

    // New version routes
    {
        path: '/compra',
        component: NewVersionPurchase,
        name: 'NewVersionPurchase'
    },

    // Stepper routes - Nueva versión con stepper
    {
        path: '/inscripcion',
        component: StepperWrapper,
        name: 'StepperWrapper',
        redirect: '/nueva-version/paso-1'
    },

    {
        path: '/inscripcion/paso-1',
        component: StepperWrapper,
        name: 'StepperStep1',
        props: { step: 1 }
    },
    {
        path: '/inscripcion/paso-2',
        component: StepperWrapper,
        name: 'StepperStep2',
        props: { step: 2 }
    },
    {
        path: '/inscripcion/paso-3',
        component: StepperWrapper,
        name: 'StepperStep3',
        props: { step: 3 }
    },
    {
        path: '/inscripcion/paso-4',
        component: StepperWrapper,
        name: 'StepperStep4',
        props: { step: 4 },
        meta: { showWhatsApp: true, hidePersonalizedAttention: true }
    },
    {
        path: '/inscripcion/paso-5',
        component: StepperWrapper,
        name: 'StepperStep5',
        props: { step: 5 },
        meta: { showWhatsApp: true, hidePersonalizedAttention: true }
    },



    {
        path: '/home',
        component: NewHome,
        name: 'NewHome'
    },      
   
]

const router = new VueRouter({

    mode: 'history',

    routes,

    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

// Manejar errores de navegación duplicada
const originalPush = router.push
const originalReplace = router.replace

router.push = function(location, onComplete, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

router.replace = function(location, onComplete, onAbort) {
    return originalReplace.call(this, location, onComplete, onAbort).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err
        }
    })
}

const protectedStep = [
    ...routes.filter(r => r.name ? r.name.startsWith('Step') : false).map(r => ({
        path: r.path,
        requireStorageKey: r.requireStorageKey ? r.requireStorageKey.split(';') : []
    }))
]
router.beforeEach((to, from, next) => {
    document.title = to.path === "/" ? "PDV - Pedro de Valdivia" :
        "PDV - " + to.path.replace('/', '').split('-').map(t => upperFirst(t)).join(" ");
    if (!from.name) { //solo cuando venga desde url
        const currentStep = protectedStep.find(pr => pr.path === to.path);
        if (currentStep) {
            const { requireStorageKey } = currentStep;
            let existKeys = 0;
            //cuenta el total de keys requeridas que se cumplan
            requireStorageKey.forEach(key => {
                if (localStorage.getItem(key)) existKeys++;
            })
            if (existKeys === requireStorageKey.length) {
                next()
            } else {
                //si no estan todas las keys requeridas redirecciona a /
                next('/')
            }
        }
    }
    next()
})



export default router; 